import $ from 'jquery';

class AssetPoller {
	

	watch(assets) {
		this.timer = 2000;

		setTimeout(() => {
			this.poll(assets);
		}, this.timer);

	}

	transform(asset, obj) {
		$(asset).removeClass("processing");
		$(asset).find(".assetprevlink").data("preview", obj.preview);
		$(asset).find(".assetprevlink").data("media", obj.media);
		$(asset).find("img").attr("src", obj.preview);
	}

	poll(assets) {

    console.log(assets);
    const ids = $(assets).map(asset => {
      return $(asset).find(".assetprevlink").data("fileid");
    });

		$.ajax({data:{op:"poll", files: ids},
			success: (ids, s) => {
				if (ids) {
					$(ids).each((i, obj) => {
						$(assets).each((i, asset) => {
							if ($(asset).find(".assetprevlink").data("fileid") == obj.id) {
								this.transform(asset, obj);

								// reload it somehow.
								assets.splice(i, 1);
							}
						})
					});

					if ($(assets).length > 0) {
						setTimeout(() => {
							this.poll(assets);
						}, this.timer);
					}
				}
			}
		});
	}

}

export default AssetPoller;
